import { IMAGE_TYPE_LEGACY, IMAGE_TYPE } from './types';
import { sizeClassName, alignmentClassName } from './classNameStrategies';
import imageComponentWrapper from './components/ImageComponentWrapper/image-component-wrapper';
import BadPlugin from '../../components/BadPlugin';
var imageRenderDescriptor = function (externalImageComponent) { return ({
    component: externalImageComponent
        ? imageComponentWrapper(externalImageComponent)
        : BadPlugin,
    classNameStrategies: {
        size: sizeClassName,
        alignment: alignmentClassName,
    },
}); };
export function typeMapper(externalImageComponent) {
    return function () {
        var _a;
        return (_a = {},
            _a[IMAGE_TYPE_LEGACY] = imageRenderDescriptor(externalImageComponent),
            _a[IMAGE_TYPE] = imageRenderDescriptor(externalImageComponent),
            _a);
    };
}
//# sourceMappingURL=typeMapper.js.map